/**
 * Main-dex perp clearinghouse state (positions + margin summary) of the session's user, from the `clearinghouseState`
 * stream the session holds. Idle when `address` is null.
 */
import type { ClearinghouseState } from '../hl/types';
import { useHeld } from './UserSession';
import type { HeldState } from './userSession';

export function usePerpPositions(address: string | null | undefined): HeldState<ClearinghouseState> {
  return useHeld('positions', address);
}
